
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./global.scss";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AuthenticateUser } from "./components/auth/AuthenticateUser";
import { Spin } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <Suspense
      fallback={
        <div style={{ display: "flex", justifyContent: "center", marginTop: 100 }}>
          <Spin />
        </div>
      }
    >
      <AuthenticateUser>
        <RouterProvider router={router} />
      </AuthenticateUser>
    </Suspense>
  </Provider>
);
